import { DECIMAL_SCALE } from '@vaultsfyi/common/utils'

interface CalculateReturnsArgs {
  timespan: number
  apy: number
  positionValue: bigint
}

export function calculateReturns({ timespan, apy, positionValue }: CalculateReturnsArgs): bigint {
  const APY_MULTIPLIER = 100n
  const DAYS_IN_YEAR = 365n
  const PERCENTAGE_MULTIPLIER = 100n

  return (
    (positionValue * BigInt(Math.round(apy * DECIMAL_SCALE)) * BigInt(timespan)) /
    APY_MULTIPLIER /
    PERCENTAGE_MULTIPLIER /
    DAYS_IN_YEAR
  )
}
